/** @jsxImportSource @emotion/react */
import React from 'react';
import Tooltip from '@reach/tooltip';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
type InfoTipProps = {
  info: React.ReactNode;
  customIcon?: React.ReactNode;
};

export const P = function ({children, className}: {children: React.ReactNode, className?: string}) {
  return <p css={{wordBreak: 'keep-all', whiteSpace: 'normal'}} className={className}>{children}</p>;
};
const InfoTip = function ({info, customIcon}: InfoTipProps) {
  return (
    <Tooltip
      label={info}
      aria-label={'input content help information'}
      style={{zIndex: 999}}
    >
      <span>
        {customIcon ? customIcon : <FontAwesomeIcon
          icon={faInfoCircle}
          css={{
            fontSize: 12,
            marginLeft: 5,
            color: '#26abe3',
            cursor: 'help',
          }}
        />}
      </span>
    </Tooltip>
  );
};

export default InfoTip;
